import { errorResponses } from '../../constants/errorCode'
import { CreateError } from './createError'

export class CustomError {
  error404(name, data) {
    const errName = name || 'Not Found'
    const errData = data || errorResponses[404]
    const createErr = new CreateError(404, errName, errData)
    createErr.errorMessage()
  }
  error500(name, data) {
    const errName = name || 'Internal Server Error'
    const errData = data || errorResponses[500]
    const createErr = new CreateError(500, errName, errData)
    createErr.errorMessage()
  }

  error400(name, data) {
    const errName = name || 'Bad Request'
    const errData = data || errorResponses[400]
    const createErr = new CreateError(400, errName, errData)
    createErr.errorMessage()
  }

  error401(name, data) {
    const errName = name || 'Unauthorized'
    const errData = data || errorResponses[401]
    const createErr = new CreateError(401, errName, errData)
    createErr.errorMessage()
  }
  error403(data) {
    const errName = 'Unauthorized'
    const errData = data || errorResponses[403]
    const createErr = new CreateError(403, errName, errData)
    createErr.errorMessage()
  }
  error409(data) {
    const errName = 'Conflict'
    const errData = data || errorResponses[403]
    const createErr = new CreateError(403, errName, errData)
    createErr.errorMessage()
  }
}
